export default "__VITE_ASSET__BDMXi7Qf__"